import "../../chunk-7QVYU63E.js";
import { z } from "zod";
const Recipient = z.object({
  userId: z.number(),
  teamId: z.number(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  isAdmin: z.boolean()
});
var RecipientGroup = /* @__PURE__ */ function(RecipientGroup2) {
  RecipientGroup2["ALL"] = "ALL";
  RecipientGroup2["ADMIN"] = "ADMIN";
  return RecipientGroup2;
}(RecipientGroup || {});
var ErrorAlertInterval = /* @__PURE__ */ function(ErrorAlertInterval2) {
  ErrorAlertInterval2["MINUTES_2"] = "MINUTES_2";
  ErrorAlertInterval2["MINUTES_5"] = "MINUTES_5";
  ErrorAlertInterval2["MINUTES_10"] = "MINUTES_10";
  ErrorAlertInterval2["MINUTES_15"] = "MINUTES_15";
  return ErrorAlertInterval2;
}(ErrorAlertInterval || {});
var ErrorAlertFrequency = /* @__PURE__ */ function(ErrorAlertFrequency2) {
  ErrorAlertFrequency2["MINUTES_2"] = "MINUTES_2";
  ErrorAlertFrequency2["MINUTES_5"] = "MINUTES_5";
  ErrorAlertFrequency2["MINUTES_10"] = "MINUTES_10";
  ErrorAlertFrequency2["MINUTES_15"] = "MINUTES_15";
  ErrorAlertFrequency2["MINUTES_30"] = "MINUTES_30";
  ErrorAlertFrequency2["HOURS_1"] = "HOURS_1";
  ErrorAlertFrequency2["HOURS_4"] = "HOURS_4";
  ErrorAlertFrequency2["HOURS_12"] = "HOURS_12";
  ErrorAlertFrequency2["HOURS_24"] = "HOURS_24";
  return ErrorAlertFrequency2;
}(ErrorAlertFrequency || {});
var ErrorAlertType = /* @__PURE__ */ function(ErrorAlertType2) {
  ErrorAlertType2["ERROR_RATE"] = "ERROR_RATE";
  return ErrorAlertType2;
}(ErrorAlertType || {});
var UsageAlertType = /* @__PURE__ */ function(UsageAlertType2) {
  UsageAlertType2["ON_DEMAND_CU"] = "ON_DEMAND_CU";
  UsageAlertType2["ON_DEMAND_DOLLAR"] = "ON_DEMAND_DOLLAR";
  UsageAlertType2["THRESHOLD_FROM_ZERO_CU"] = "THRESHOLD_FROM_ZERO_CU";
  UsageAlertType2["THRESHOLD_FROM_ZERO_DOLLAR"] = "THRESHOLD_FROM_ZERO_DOLLAR";
  return UsageAlertType2;
}(UsageAlertType || {});
var AlertKind = /* @__PURE__ */ function(AlertKind2) {
  AlertKind2["ERROR"] = "ERROR";
  AlertKind2["USAGE"] = "USAGE";
  return AlertKind2;
}(AlertKind || {});
var ChannelType = /* @__PURE__ */ function(ChannelType2) {
  ChannelType2["UNSPECIFIED"] = "UNSPECIFIED";
  ChannelType2["SLACK"] = "SLACK";
  ChannelType2["TELEGRAM"] = "TELEGRAM";
  return ChannelType2;
}(ChannelType || {});
const BaseAlert = z.object({
  id: z.number(),
  teamId: z.number(),
  active: z.boolean(),
  name: z.string(),
  recipients: z.array(Recipient),
  recipientGroups: z.array(z.nativeEnum(RecipientGroup)),
  vipChannel: z.nativeEnum(ChannelType).optional(),
  appIds: z.array(z.number()).optional(),
  networks: z.array(z.string()).optional(),
  methods: z.array(z.string()).optional()
});
const ErrorAlert = BaseAlert.merge(z.object({
  type: z.nativeEnum(ErrorAlertType),
  interval: z.nativeEnum(ErrorAlertInterval),
  frequency: z.nativeEnum(ErrorAlertFrequency),
  percentThreshold: z.number().int().positive().max(1e4),
  kind: z.literal("ERROR")
}));
const UsageAlert = BaseAlert.merge(z.object({
  type: z.nativeEnum(UsageAlertType),
  threshold: z.number(),
  kind: z.literal("USAGE")
}));
const Alert = z.discriminatedUnion("type", [
  ErrorAlert,
  UsageAlert
]);
export {
  Alert,
  AlertKind,
  BaseAlert,
  ChannelType,
  ErrorAlert,
  ErrorAlertFrequency,
  ErrorAlertInterval,
  ErrorAlertType,
  Recipient,
  RecipientGroup,
  UsageAlert,
  UsageAlertType
};
//# sourceMappingURL=alerts.js.map